import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SumsubService } from '@/core/services/sumsubService';
import { TravelRuleStatus } from '@/store/auth/enum';
import TravelRuleModal from './index';
import DvModal from '../dv-modal';

const TravelRuleStartupModal: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  const { data: travelRuleStatus } = useQuery({
    queryKey: ['travelRuleStatusStartup'],
    queryFn: SumsubService.getTravelRuleStatus,
    staleTime: 60000, // Cache for 1 minute
    retry: false,
  });

  useEffect(() => {
    if (travelRuleStatus) {
      const needsAction =
        travelRuleStatus.status === TravelRuleStatus.NEEDED ||
        travelRuleStatus.status === TravelRuleStatus.FAILED;

      if (needsAction) {
        setShowModal(true);
      }
    }
  }, [travelRuleStatus]);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <DvModal open={showModal} onClose={handleClose}>
      <TravelRuleModal onClose={handleClose} isFullModal={true} />
    </DvModal>
  );
};

export default TravelRuleStartupModal;
